import React, { useEffect, useState } from 'react';
import { Box, Image, VStack, Text } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../stateManagement/auth/useAuth';

const CDN_URL = process.env.REACT_APP_CDN_URL;

export const LoginPage: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  // Extract parameters from the URL
  const queryParams = new URLSearchParams(location.search);
  const error = queryParams.get('error');
  // const claimedId = queryParams.get('openid.claimed_id');

  // useEffect(() => {
  //   // Handle Steam OpenID response
  //   if (claimedId) {
  //     // const parts = claimedId.split('/');
  //     // const extractedId = parts[parts.length - 1];
  //     // console.log('Steam ID', extractedId);
  //     // handleLogin('steam', extractedId);
  //   }
  // }, [claimedId, handleLogin]);

  useEffect(() => {
    //  Add delay to ensure MSAL has processed redirect
    const checkAuth = async () => {
      // Wait for MSAL to finish processing redirect
      await new Promise<void>(resolve => {
        setTimeout(resolve, 100);
      });

      if (isAuthenticated) {
        //  Use replace instead of navigate to prevent back button issues
        navigate('/', { replace: true });
      } else {
        setIsCheckingAuth(false);
      }
    };

    checkAuth();
  }, [isAuthenticated, navigate]);

  if (isCheckingAuth) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" height="100vh" bg="gray.900">
        <Text color="white">Checking authentication status...</Text>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      bg="gray.900"
      color="white"
    >
      {error && (
        <Box
          bg="gray.700"
          border="1px solid red"
          maxW="300px"
          color="white"
          p={3}
          mb={4}
          borderRadius="md"
          textAlign="center"
          fontWeight="bold"
          textColor="red"
        >
          Error: {error}
        </Box>
      )}
      <Text fontSize="2xl" mb={6} fontWeight="bold">
        Login with your account
      </Text>
      <VStack spacing={4} w="100%" maxW="300px">
        {/* Epic Games Login */}
        <Box
          p={2}
          display="flex"
          alignItems="center"
          w="100%"
          bg="gray.700"
          borderRadius="md"
          cursor="pointer"
          _hover={{ bg: 'gray.600' }}
          border="1px solid white"
        >
          <Box w={20} h={20}>
            <Image
              src={`${CDN_URL}/images/epiclogo.png`}
              alt="Epic Games"
              borderRadius="md"
              objectFit="fill"
              w="100%"
              h="100%"
              mr={4}
            />
          </Box>
          <Text p={2} align="center" fontWeight="medium">
            Login With Epic Games
          </Text>
        </Box>

        {/* Steam Login */}
        <Box
          p={2}
          onClick={() => {
            window.location.replace(
              `https://steamcommunity.com/openid/login?openid.ns=http://specs.openid.net/auth/2.0&openid.mode=checkid_setup&openid.return_to=https://demohc.ms.helpshift.live/login/authresp&openid.realm=https://demohc.ms.helpshift.live&openid.identity=http://specs.openid.net/auth/2.0/identifier_select&openid.claimed_id=http://specs.openid.net/auth/2.0/identifier_select`,
            );
          }}
          display="flex"
          alignItems="center"
          w="100%"
          bg="gray.700"
          borderRadius="md"
          cursor="pointer"
          _hover={{ bg: 'gray.600' }}
          border="1px solid white"
        >
          <Box w={20} h={20}>
            <Image
              src={`${CDN_URL}/images/steamlogo.png`}
              alt="Steam"
              borderRadius="md"
              objectFit="fill"
              w="100%"
              h="100%"
            />
          </Box>
          <Text p={2} align="center" fontWeight="medium">
            Login With Steam Account
          </Text>
        </Box>
      </VStack>
    </Box>
  );
};
